export default __webpack_public_path__ + "static/media/ingame.5a4c931f.png";